import { useContext, useEffect, useState, useRef } from "react"
import { AppContext } from "../App"
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { callApi, CDN_URL, formatDate, formatMoney, formatMoneyShorten, generateRandomString, getInlineLoaderMin, remove255, WEB_SOCKET_URL } from "../Helpers";
import { FaChalkboardTeacher } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosAttach, IoIosImage, IoIosPeople, IoIosSend } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import SubscriptionExpiredWidget from '../ones/SubscriptionExpiredWidget';
import { STR_ENTER_PHONE_NUMBER_FOR_PAYMENT, STR_FEMALE, STR_FINALIZE_PAYMENT_CARD, STR_FINALIZE_PAYMENT_MOBILE, STR_MALE, STR_NO_CHAT_WAS_FOUND, STR_NO_MESSAGES, STR_PAY_NOW, STR_PAY_WITH_CARD, STR_PAY_WITH_MOBILE, STR_PER_SESSION, STR_PHONE_NUMBER, STR_SELECT_PAYMENT_METHOD, STR_START_CHAT_WITH_MEMBER, STR_SUCCESS, STR_YES } from "../Strings";
import { TiUser } from "react-icons/ti";
import { BsImage } from "react-icons/bs";
import MobileInterface from "../MobileInterface";
import { MdCheckCircle } from "react-icons/md";


export default function View({ doctorId }) {

  const appContext = useContext(AppContext);

  /* Place states here */
  const [ready, setReady] = useState(false);
  const [payWith, setPayWith] = useState('mobile_money');
  const [payPhone, setPayPhone] = useState(remove255(appContext.currentUserData.phone));
  const [loading, setLoading] = useState(false);
  const [opSuccessful, setOpSuccessful] = useState(false);
  const [doctorData, setDoctorData] = useState(null);


  async function init() {
    //run initializations here
    setReady(false);
    await getDoctorData().then((_data) => {
      setReady(true);
    });
  }

  function getDoctorData() {
    return new Promise(async (resolve) => {
      await callApi("get-doctor-data", { id: doctorId }).then(response => {
        if (response.status === 1) {
          setDoctorData(response.data);
          resolve(response.data);
        } else {
          resolve(false)
        }
      })
    })
  }

  async function pay() {
    if (!loading) {
      if (payWith.trim().length > 0) {
        if (payWith === 'credit_card' || (payWith === 'mobile_money' && payPhone.trim().length === 10)) {
          setLoading(true);
          await callApi('create-consultation-order', { payWith, payPhone, doctorId }).then(response => {
            if (response.status === 1) {
              setOpSuccessful(true)
              if (payWith === 'credit_card') {
                MobileInterface.openLink(response.payment_gateway_url);
              }
            } else {
              appContext.tellError(response.msg)
            }
          })
          setLoading(false)
        } else {
          appContext.tellError("Invalid phone number");
        }
      } else {
        appContext.tellError("Invalid payment method");
      }
    } else {
      appContext.tellInfo("Please wait....");
    }
  }

  useEffect(() => {
    init();
  }, [doctorId])



  useEffect(() => {
    appContext.setShowOverlayLoader(loading);
  }, [loading])

  if (ready && doctorData) {
    return (
      <div className="container">

        {
          (opSuccessful) ?
            <div className="col-md-12 mt-4 mb-4 text-center" style={{ padding: "40px" }}>

              <h1
                style={{
                  fontSize: "20px",
                }}
              >
                <MdCheckCircle size={70} className="text-secondary" /> <br />
                {(payWith === 'mobile_money') ? STR_FINALIZE_PAYMENT_MOBILE[appContext.language] : STR_FINALIZE_PAYMENT_CARD[appContext.language]}
              </h1>
            </div>
            :
            <div
              className=""
              style={{
                width: "100%",
                padding: "10px",
              }}
            >
              <h6
                className="mb-2 mt-2"
                style={{
                  fontSize: "28px",
                }}
              >
                {doctorData.doctorFullname}
              </h6>

              <h6
                style={{
                  fontSize: "32px",
                }}
                className="mb-4 mt-4 font-bold"
              >
                {formatMoney(doctorData.doctorConsultationFee)} TZS
                <span
                  style={{
                    fontSize: "14px",
                    display: "block",
                  }}
                  className="text-muted"
                >
                  {STR_PER_SESSION[appContext.language]}
                </span>
              </h6>

              <div className="mb-2 mt-2">
                <label>{STR_SELECT_PAYMENT_METHOD[appContext.language]}</label>
                <select
                  className="form-control"
                  value={payWith}
                  onChange={(e) => setPayWith(e.target.value)}
                >
                  <option value="mobile_money">{STR_PAY_WITH_MOBILE[appContext.language]}</option>
                  <option value="credit_card">{STR_PAY_WITH_CARD[appContext.language]}</option>
                </select>
              </div>

              {
                (payWith === 'mobile_money') ?
                  <div className="mt-2 mb-2">
                    <label className="form-label">{STR_PHONE_NUMBER[appContext.language]}</label>
                    <input
                      className="form-control"
                      maxLength={10}
                      value={payPhone}
                      onChange={(e) => setPayPhone(e.target.value)}
                    />

                  </div>
                  : ""
              }

              <button
                className="btn btn-secondary btn-rounded btn-padded btn-block mt-4 mb-4"
                onClick={pay}
                style={{
                  textTransform: "uppercase"
                }}
              >
                {STR_PAY_NOW[appContext.language]}
              </button>
            </div>
        }

      </div>
    )
  } else {
    return (
      <div
        className="mSupportLoading container"
      >
        {getInlineLoader()}
      </div>
    );
  }


}